import { Form } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledField = styled(Form.Field)`
 .field{ 
    margin-bottom: 0px !important;
  }
`